module.exports = __webpack_public_path__ + "static/media/tsb7ru.746a6c4c.pdf";